import type { Maybe } from '@tectonics/utils/types';
import type { CheckoutReceipts } from '../types';
import type { CardBrand } from '@tectonics/prs/card-brand';

const CARD_PAYMENT_METHODS_RESOLVED_BY_BRAND: readonly string[] = ['creditcard', 'google', 'debitcard'];

export function getReceiptSource(receipts: CheckoutReceipts, paymentTypeCode: Maybe<string>): CheckoutReceipts {
  const snapshot = paymentTypeCode == null ? undefined : receipts.fx_latency?.[paymentTypeCode];

  if (!snapshot) return receipts;

  return { ...receipts, main: snapshot.main, instalments: snapshot.instalments };
}

/**
 * Resolves the `payment_type` code used as the key of the `fx_latency` node.
 * For card methods the code is the detected brand; for every other method it is the
 * selected method code itself. Returns `undefined` when a card brand is not yet known.
 */
export function resolvePaymentTypeCode(selectedPaymentMethod: string, cardBrand: Maybe<CardBrand>): Maybe<string> {
  if (CARD_PAYMENT_METHODS_RESOLVED_BY_BRAND.includes(selectedPaymentMethod)) return cardBrand ?? undefined;

  return selectedPaymentMethod;
}
